import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function BrokerRegistrationModal({ onClose }) {
    const [systems, setSystems]         = useState([]);
    const [ico, setIco]                 = useState('');
    const [aresName, setAresName]       = useState('');
    const [aresAddr, setAresAddr]       = useState('');
    const [aresLoading, setAresLoading] = useState(false);
    const [aresError, setAresError]     = useState('');
    const [email, setEmail]             = useState('');
    const [phone, setPhone]             = useState('');
    const [systemId, setSystemId]       = useState('');
    const [termsAgreed, setTermsAgreed] = useState(false);
    const [honeypot, setHoneypot]       = useState('');
    const [submitting, setSubmitting]   = useState(false);
    const [done, setDone]               = useState(false);
    const [error, setError]             = useState('');

    useEffect(() => {
        axios.get('/api/broker-registration/systems/')
            .then(r => setSystems(r.data))
            .catch(() => {});
    }, []);

    const lookupIco = async () => {
        const v = ico.replace(/\s/g, '');
        if (!/^\d{8}$/.test(v)) { setAresError('IČO musí mít 8 číslic.'); return; }
        setAresLoading(true); setAresError(''); setAresName(''); setAresAddr('');
        try {
            const r = await axios.get(`/api/ares/${v}/`);
            setAresName(r.data.name);
            setAresAddr(r.data.address);
        } catch (e) {
            setAresError(e.response?.data?.error || 'Firma nenalezena v ARES.');
        } finally {
            setAresLoading(false);
        }
    };

    const handleIcoBlur = () => {
        if (ico.replace(/\s/g, '').length === 8) lookupIco();
    };

    const submit = async (e) => {
        e.preventDefault();
        setError('');
        if (!aresName) { setError('Nejdříve ověřte IČO.'); return; }
        if (!termsAgreed) { setError('Je nutné souhlasit s podmínkami spolupráce.'); return; }
        setSubmitting(true);
        try {
            await axios.post('/api/broker-registration/', {
                ico: ico.replace(/\s/g, ''),
                name: aresName,
                address: aresAddr,
                email,
                phone,
                system_id: systemId,
                terms_agreed: true,
                honeypot,
            });
            setDone(true);
        } catch (e) {
            setError(e.response?.data?.error || 'Nastala chyba. Zkuste to znovu.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="modal-overlay broker-reg-overlay" onClick={onClose}>
            <div className="modal-box broker-reg-modal" onClick={e => e.stopPropagation()}>
                <button className="modal-close-btn" onClick={onClose}>✕</button>

                {done ? (
                    <div className="broker-reg-success">
                        <div className="broker-reg-success-icon">✅</div>
                        <h3>Registrace proběhla úspěšně!</h3>
                        <p>
                            Přístupové údaje jsme odeslali na <strong>{email}</strong>.<br />
                            Brzy obdržíte e-mail s Client ID, heslem a softwarovým klíčem.
                        </p>
                        <button className="btn btn-primary" onClick={onClose}>Zavřít</button>
                    </div>
                ) : (
                    <>
                        <h2 className="broker-reg-title">Registrace realitní kanceláře</h2>
                        <p className="broker-reg-subtitle">
                            Vyplňte formulář a získejte přístupové údaje pro export nemovitostí na Prahanoi.cz.
                        </p>

                        <form onSubmit={submit} className="broker-reg-form">

                            {/* Honeypot — hidden from humans, filled only by bots */}
                            <input
                                type="text"
                                name="website"
                                style={{display:'none'}}
                                tabIndex={-1}
                                autoComplete="off"
                                value={honeypot}
                                onChange={e => setHoneypot(e.target.value)}
                            />

                            {/* IČO */}
                            <div className="form-group">
                                <label>IČO <span className="required-star">*</span></label>
                                <div className="input-with-btn">
                                    <input
                                        type="text"
                                        placeholder="12345678"
                                        value={ico}
                                        onChange={e => { setIco(e.target.value); setAresName(''); setAresAddr(''); setAresError(''); }}
                                        onBlur={handleIcoBlur}
                                        maxLength={8}
                                        required
                                    />
                                    <button type="button" className="btn btn-verify" onClick={lookupIco} disabled={aresLoading}>
                                        {aresLoading ? '…' : 'Ověřit'}
                                    </button>
                                </div>
                                {aresError && <div className="form-error">{aresError}</div>}
                            </div>

                            {/* ARES readonly fields */}
                            <div className="form-group">
                                <label>Název firmy <span className="required-star">*</span></label>
                                <input
                                    type="text"
                                    value={aresName}
                                    placeholder="Doplní se po ověření IČO"
                                    disabled
                                    className="ares-readonly"
                                />
                            </div>

                            <div className="form-group">
                                <label>Sídlo firmy <span className="required-star">*</span></label>
                                <input
                                    type="text"
                                    value={aresAddr}
                                    placeholder="Doplní se po ověření IČO"
                                    disabled
                                    className="ares-readonly"
                                />
                            </div>

                            {/* Email */}
                            <div className="form-group">
                                <label>Kontaktní e-mail <span className="required-star">*</span></label>
                                <input
                                    type="email"
                                    placeholder="kancelar@firma.cz"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    required
                                />
                            </div>

                            {/* Phone */}
                            <div className="form-group">
                                <label>Telefon <span className="optional">(nepovinné)</span></label>
                                <input
                                    type="tel"
                                    placeholder="+420 777 000 000"
                                    value={phone}
                                    onChange={e => setPhone(e.target.value)}
                                />
                            </div>

                            {/* System */}
                            <div className="form-group">
                                <label>Realitní software <span className="required-star">*</span></label>
                                <p className="broker-reg-softreal-info">
                                    <i>* Softreal: registraci proveďte přímo v administraci Softreal pod sekcí <strong>Exporty</strong>.</i>
                                </p>
                                <div className="system-list">
                                    {systems.map(s => {
                                        const isSoftreal = s.name.toLowerCase().includes('softreal');
                                        return (
                                        <label key={s.id} className={`system-row${isSoftreal ? ' disabled' : ''}`}
                                            title={isSoftreal ? 'Registraci proveďte přímo v administraci Softreal → Exporty' : undefined}>
                                            <input
                                                type="radio"
                                                name="system_id"
                                                value={s.id}
                                                checked={String(systemId) === String(s.id)}
                                                disabled={isSoftreal}
                                                onChange={() => setSystemId(s.id)}
                                            />
                                            {s.logo_url
                                                ? <img src={s.logo_url} alt={s.name} className={`system-row__logo${s.logo_dark_bg ? ' dark-bg' : ''}`} />
                                                : s.name
                                            }
                                            {isSoftreal && <span className="system-row__hint"> — viz Softreal admin → Exporty</span>}
                                        </label>
                                        );
                                    })}
                                </div>
                                <p className="broker-reg-no-system">
                                    Nemáte žádný z těchto systémů? Kontaktujte nás pro individuální řešení:{' '}
                                    <a href="mailto:info@prahanoi.cz">info@prahanoi.cz</a>
                                    {' '}nebo{' '}
                                    <a href="tel:+420777003446">+420 777 003 446</a>.
                                </p>
                            </div>

                            {error && <div className="form-error">{error}</div>}

                            <label className="broker-reg-conditions">
                                <input
                                    type="checkbox"
                                    checked={termsAgreed}
                                    onChange={e => setTermsAgreed(e.target.checked)}
                                    required
                                />
                                {' '}<span>
                                    Souhlasím s{' '}
                                    <a href="/broker-terms/" target="_blank" rel="noopener">podmínkami spolupráce</a>
                                    {' '}a beru na vědomí{' '}
                                    <a href="/privacy-policy/" target="_blank" rel="noopener">ochranu osobních údajů</a>.
                                </span>
                            </label>

                            <button type="submit" className="btn btn-primary btn-full" disabled={submitting || !aresName || !termsAgreed || !systemId}>
                                {submitting ? 'Odesílám…' : 'Získat přístupové údaje'}
                            </button>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
}
